/// <amd-module name="typeahead/features/NearbyAirportParamModifier" />

import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Flights.Search"],
        experiment: {
            id: 15334,
            name: "FSRP_uTA_NearbyAirports",
            value: 1,
        },
    },
    {
        lobs: ["FLIGHTS"],
    },
];

const featureFlag: string = "nearby_airport";

export class NearbyAirportParamModifier implements IExperimentalFeature, IRequestUrlParamModifier {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            JQueryPromise<ISuggestServiceQueryParams> {
        const deferred: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
        ExecutionHelper.shouldExecute(context, configuration)
            .done((shouldExecute) => {
                if (shouldExecute) {
                    addFeatureFlag(featureFlag, configuration, params, context, options)
                        .done((newParams) => {
                            deferred.resolve(newParams);
                        })
                        .fail(() => {
                            deferred.resolve(params);
                        });
                } else {
                    deferred.resolve(params);
                }
            })
            .fail(() => {
                deferred.resolve(params);
            });
        return deferred;
    }

    public getExperiments(): UtaExperiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }
}
